import { render } from "./WorkWithUs.vue?vue&type=template&id=7475392e&scoped=true"
import script from "./WorkWithUs.vue?vue&type=script&lang=js"
export * from "./WorkWithUs.vue?vue&type=script&lang=js"

import "./WorkWithUs.vue?vue&type=style&index=0&id=7475392e&scoped=true&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7475392e"]])

export default __exports__